import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type ScoringFragment = {
	__typename: 'Scoring';
	imdbScore?: number | null;
	imdbVotes?: number | null;
	tmdbPopularity?: number | null;
	tmdbScore?: number | null;
	jwRating?: number | null;
	tomatoMeter?: number | null;
	certifiedFresh?: boolean | null;
	hideJWRating: boolean;
};

export const ScoringFragmentDoc = gql`
	fragment Scoring on Scoring {
		__typename
		imdbScore
		imdbVotes
		tmdbPopularity
		tmdbScore
		jwRating
		tomatoMeter
		certifiedFresh
		hideJWRating
	}
`;
